import { CheckCircle2 } from "lucide-react";
import { PageShell, PageHero } from "@/components/marketing/PageShell";
import { STATUS } from "@/content/pages";

export default function Status() {
  return (
    <PageShell testid="status-root" seo={{
      title: "System Status — Sema",
      description: "Current operational status of Sema's API, web application, query engine, authentication and email delivery.",
      keywords: "sema status, system status, uptime",
      path: "/status",
    }}>
      <PageHero testid="status-h1" eyebrow="Status"
        title="System status." />

      <section className="pb-24">
        <div className="mx-auto w-full max-w-3xl px-6">
          <div data-testid="status-overall" className="flex items-center gap-3 rounded-2xl border border-accent/40 bg-accent/10 px-6 py-5">
            <CheckCircle2 className="h-6 w-6 text-accent" />
            <span className="text-lg font-semibold tracking-tight">{STATUS.overall}</span>
          </div>

          <div className="mt-6 divide-y divide-border/50 overflow-hidden rounded-2xl border border-border/60 bg-card/40">
            {STATUS.components.map((c) => (
              <div key={c.name} data-testid={`status-${c.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                className="flex items-center justify-between px-6 py-4">
                <span className="flex items-center gap-2.5 text-sm font-medium">
                  <span className="h-2 w-2 rounded-full bg-accent" />{c.name}
                </span>
                <span className="font-mono text-[11px] uppercase tracking-[0.14em] text-muted-foreground">
                  Operational · {c.uptime}
                </span>
              </div>
            ))}
          </div>
          <p className="mt-6 text-sm leading-relaxed text-muted-foreground">{STATUS.note}</p>
        </div>
      </section>
    </PageShell>
  );
}
